import type { ExternalGroupFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (item: ExternalGroupFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.name,
    icon: "fas fa-users",
    iconBackground: item.color || undefined,
  };
};

const toOption = (item: ExternalGroupFragment): IOption => {
  return {
    value: item.id,
    title: item.name,
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
